import { normalize } from 'normalizr';

import { callApi, pageToOffsetParams } from 'utils/api';
import * as schemas from 'schemas';

export function magazineArticlesFetch(page, { sort = 'recent', local = false, following = false, favourite = false, topic = [] } = {}) {
  return callApi('/article', {
    query: {
      sort,
      local,
      following,
      favourite,
      topic,
      ...pageToOffsetParams(page, process.env.KOOTH_PAGE_SIZE)
    }
  })
  .then(json => {
    const { articles, meta }  = json;
    const { result, entities } = normalize(articles, schemas.magazineArticlesArraySchema);

    return {magazineArticlesIds: result, entities, meta};
  });
}

export function magazineArticleProfileFetch(magazineArticleId) {
  return callApi(`/article/${magazineArticleId}`)
  .then(json => {
      const entities = {
        magazineArticles: {
          [magazineArticleId]: json
        }
      };

      return {magazineArticlesIds: [magazineArticleId], entities};
  });
}

export function magazineArticleCreate(title, text) {
  return callApi('/article', {
    method: 'POST',
    body: {
      title,
      text
    }
  });
}

export function magazineArticleFollow(magazineArticleId, following) {
  return callApi(`/article/${magazineArticleId}/following`, {
    method: 'POST',
    body: {
      following
    }
  });
}

export function magazineArticleFavourite(magazineArticleId, favourite) {
  return callApi(`/article/${magazineArticleId}/favourite`, {
    method: 'POST',
    body: {
      favourite
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/api.js
 **/